<div class="title">
    <h2 class="title-element default">{{ title }}</h2>
    <template v-for="(title, index) in elements" :key="index">
        <router-link
            v-if="title.link"
            :class="`title-element ${title.selected ? 'selected' : null}`"
            :to="title.link">
            <AppIcon mdi icon="chevron-right" medium />
            <h2>{{ title.name }}</h2>
        </router-link>
        <div
            v-else
            :class="`title-element ${title.selected ? 'selected' : null}`"
            @click="titleElementClick(title.id ? title.id : title.name)">
            <AppIcon mdi icon="chevron-right" medium />
            <h2>{{ title.name }}</h2>
        </div>
    </template>
</div>